import React from 'react';
import { starEmpty, starYellow } from 'static/icons/resizable';
import { ITypes, Icon, Text } from 'view/atoms';
import * as S from './RatingBadge.styles';

type IRatingBadgeProps = ITypes & {
  averageRating?: number | null;
};

export const RatingBadge = ({ kind, averageRating }: IRatingBadgeProps) => {
  const hasRating = typeof averageRating === 'number' && averageRating > 0;

  return (
    <S.RatingBadgeStyle>
      <Icon
        src={hasRating ? starYellow : starEmpty}
        alt='Rating star icon'
        style={{ width: '24px', height: '24px' }}
      />
      {hasRating && <Text kind={kind}>{Number(averageRating.toFixed(1))}</Text>}
    </S.RatingBadgeStyle>
  );
};
